import React, { FC } from 'react';
import { IconDefinitions } from '../..';

export interface IconProps {
  icon: IconDefinitions;
  size?: number;
  color?: string;
}

export const Icon: FC<IconProps> = (props) => {
  const { icon, size = 16, color = 'inherit' } = props;
  
  return (
    <i className={`dew-icon icon--${icon}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: color,
        fontSize: `${size}px`,
        lineHeight: `${size}px`,
        backgroundSize: 'cover',
      }} />
  );
};
